/* global locales */
import angular from 'angular';
import moment from 'moment';
import 'ui-select';
import 'ng-flow';
import './priceListsServices';
import locales from "@/scripts/locale";

const controllers = angular.module('applicationModule.priceListsControllers', [
    'applicationModule.priceListsServices',
    'flow',
    'ui.select',
    'ngTable'
]);

controllers.controller('PriceListsController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', '$modal', 'growl', 'PriceList', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $stateParams, NgTableParams, $modal, growl, PriceList, AppsoupAPI, Permissions) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('price_lists');
    $scope.application_id = $stateParams.application_id;

    $scope.isLoadingExport = false;
    $scope.isSynchronizing = false;

    // DatePickers
    $scope.syncro_date = new Date();

    $scope.popup_start = {
        opened: false
    };


    $scope.format = 'dd-MM-yyyy';

    $scope.dateOptions = {
        dateDisabled: false,
        formatYear: 'yy',
        startingDay: 1
    };

    $scope.startDate = function () {
        $scope.popup_start.opened = true;
    };

    $scope.syncroPriceList = function (appId) {
        $scope.isSynchronizing = true;
        PriceList.syncroPriceList(appId)
            .then(function (response) {
                $scope.isSynchronizing = false;
                if (response.data.success) {
                    $scope.promotions = response.data.data;
                    growl.success('MODULES.PRICE_LISTS.SUCCESS.SYNCRO');
                }
            });
    };

    function openModal(response) {
        $modal.open({
            templateUrl: 'views/application/price_lists/syncro_info_modal.tpl.html',
            controller: 'SyncroImagesAndCategoriesInfoModalController',
            animation: true,
            size: 'lg',
            resolve: {
                response: function () {
                    return response;
                }
            }
        });
    }

    $scope.downloadImagesAndCategories = function (appId) {
        $scope.isLoadingDownload = true;
        PriceList.downloadImagesAndCategories(appId)
            .then(function (response) {
                growl.success('MODULES.PRICE_LISTS.SUCCESS.DOWNLOAD_IMAGES');
                $scope.isLoadingDownload = false;
                openModal(response.data);
            });
    };

    PriceList.getSyncroPriceList($scope.application_id)
        .then(function (response) {
            if (response.data.success) {
                $scope.promotions = response.data.data;
            }
        });

    PriceList.getSyncroPriceVersion($scope.application_id)
        .then(function (response) {
            if (response.data.success) {
                $scope.version = response.data.version;
            }
        });

    PriceList.getData($scope.application_id)
        .then(function (response) {
            if (response.data.success) {
                $scope.package_id = response.data.packageId;
                $scope.mobile_activation = response.data.mobile_activation;
            }
        });

    $scope.syncroPriceListByDay = function (date) {
        $scope.isLoadingExport = true;
        var dateSyncro = moment(date).format('YYYY-MM-DD');
        PriceList.syncroPriceListByDay($scope.application_id, dateSyncro)
            .then(function (result) {
                let data = result.data;

                if (angular.isDefined(data.error)) {
                    growl.error(data.error);
                } else if (data) {
                    angular.openInNewTab(data);
                } else {
                    growl.error(data.error);
                }
                $scope.isLoadingExport = false;
            });
    };
}]);

controllers.controller('PriceListImportController', ['$state', '$scope', '$rootScope', '$stateParams', 'growl', 'PriceList', '$filter', '$locale', function ($state, $scope, $rootScope, $stateParams, growl, PriceList, $filter, $locale) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }
    $scope.editMode = false;
    $scope.imageProducts = [];

    $scope.requiredFields = [
        '"page_number"',
        '"order"',
        '"product_id"',
        '"price"',
        '"deli_price"',
        '"from_date"',
        '"to_date"',
        '"mutation"',
        '"multipack_without_delicard"',
        '"multipack_with_delicard"',
        '"promotion"',
        '"leaflet_id"',
        '"promotion_order"',
        '"badge"',
        '"badge_desc"',
        '"badge_optional"'
    ];

    $scope.optionalFields = [
        '"action_title"',
        '"action_from_date"',
        '"action_to_date"',
        '"action_price"',
        '"action_description"',
        '"action_additional_description"',
        '"action_image"',
        '"action_deeplink"',
        '"additional_promotion"',
        '"CenaOmnibus"',
        '"Data"',
        '"CenaKrotkiTermin"'
    ];

    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.errorRequired = false;

    $scope.removeFile = function () {
        $scope.upload = undefined;
        $scope.errorRequired = true;
        $scope.fileUploaded = false;
    };

    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.errorRequired = false;
        $scope.fileUploaded = true;
        $scope.fileError = false;
        $scope.$apply();
    };

    $scope.getExampleXls = function () {
        $scope.isLoading = false;
        PriceList.getExampleXls().then(function (result) {
            let data = result.data;

            angular.openInNewTab(data);
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.importData = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        $scope.correctProducts = [];
        $scope.noBadgeProducts = [];
        $scope.wrongProducts = [];
        $scope.imageProducts = [];
        PriceList.importData($scope.application_id, $scope.upload).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.noBadgeProducts = data.noBadgeProducts;
                $scope.correctProducts = data.correctProducts;
                $scope.wrongProducts = data.wrongProducts;
                $scope.imageProducts = data.imageProducts;
                $scope.imported = true;
                growl.success('MODULES.APPLICATIONS.MODULES.USERS.IMPORT.SUCCESS');
                $scope.upload = undefined;
                $scope.fileUploaded = false;
            } else {
                growl.error(data.error, {title: 'IMPORT.HEADER.DEFAULT'});
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.price_lists');
    };
}]);

controllers.controller('SyncroImagesAndCategoriesInfoModalController', ['$scope', '$rootScope', '$stateParams', '$state', 'growl', 'Permissions', '$modalInstance', 'response', function ($scope, $rootScope, $stateParams, $state, growl, Permissions, $modalInstance, response) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('price_lists');
    $scope.application_id = $stateParams.application_id;

    $scope.infoData = [];

    if (response && response.data) {
        $scope.infoData = response.data.info ? response.data.info : [];
    }

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
}]);

export default controllers;
